/**
 * Tests API Endpoints
 * Centralized endpoint definitions for test operations.
 */
export const TESTS_ENDPOINTS = {
  /**
   * Get all tests
   * @method GET
   * @endpoint /tests
   * @query TestsQueryParams
   */
  TESTS: "/tests",

  /**
   * Create a new test
   * @method POST
   * @endpoint /tests
   */
  CREATE_TEST: "/tests",

  /**
   * Get a specific test by ID
   * @method GET
   * @endpoint /tests/{id}
   * @param {number} id - Test ID
   * @query TestsQueryParams
   */
  TEST_BY_ID: (id: number) => `/tests/${id}`,

  /**
   * Update a test
   * @method PUT
   * @endpoint /tests/{id}
   * @param {number} id - Test ID
   */
  UPDATE_TEST: (id: number) => `/tests/${id}`,

  /**
   * Delete a test
   * @method DELETE
   * @endpoint /tests/{id}
   * @param {number} id - Test ID
   */
  DELETE_TEST: (id: number) => `/tests/${id}`,

  /**
   * Get tests by instrument ID with filtering
   * @method GET
   * @endpoint /tests/by-instrument/{instrumentId}
   * @param {number} instrumentId - Instrument ID
   * @query TestsByInstrumentParams
   */
  TESTS_BY_INSTRUMENT: (instrumentId: number) => `/tests/by-instrument/${instrumentId}`,
} as const;
